import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery } from '../../styles';

const StyledContainer = styled.div`
  --gutter-width: 30px;
  margin-right: auto;
  margin-left: auto;
  padding-right: var(--gutter-width);
  padding-left: var(--gutter-width);
  width: 100%;
  max-width: calc(
    ${({ narrowest, narrower, narrow, wide, wider }) =>
        narrowest
          ? '480'
          : narrower
          ? '900'
          : narrow
          ? '980'
          : wide
          ? '1500'
          : wider
          ? '1800'
          : '1240'}px + (var(--gutter-width) * 2)
  );

  ${minBreakpointQuery.large`
    --gutter-width: 45px;
  `}

  ${minBreakpointQuery.xxlarge`
    --gutter-width: 60px;
  `}
`;

export const Container = ({
  narrower,
  narrow,
  wide,
  wider,
  children,
  ...props
}) => (
  <StyledContainer
    narrower={narrower}
    narrow={narrow}
    wide={wide}
    wider={wider}
    {...props}
  >
    {children}
  </StyledContainer>
);
